import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=5f900d93&scoped=true&"
import script from "./remarks.vue?vue&type=script&lang=js&"
export * from "./remarks.vue?vue&type=script&lang=js&"
import style0 from "./remarks.vue?vue&type=style&index=0&id=5f900d93&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f900d93",
  null
  
)

export default component.exports